import React from "react";
import styles from "./DressingChangeFrequency.module.scss";

export const DressingChangeFrequencyItem = ({ item, index, type, editable, numValidator, onFrequencyChange, onFrequencyTypeChange }) => (
  <div key={index} className="my-4">
    <div className={styles.edit_wrapper}>
      <div className={styles.cat}>{item.key === "-1" ? item?.materialNumber : item.productFamilyDesc}</div>
      <div>
        {`${item.materialDescription ? `${item.materialDescription} - `: ""} ${
          !editable ? (item.frequence != null && item.frequence !== undefined && item.frequence !== "" ? `${item.frequence}` : "") : ""
        } ${
          !editable
            ? item?.frequence !== null && item.frequence !== undefined && item.frequence !== ""
              ? item?.frequenceType
                ? item?.frequenceType
                : ""
              : ""
            : ""
        }`}
      </div>
    </div>

    {editable && (
      <>
        <div className={styles.recom_text}>Recommended : {item.recommended}</div>
        <div className={styles.treatment_text}>Dressing Change Frequency</div>
        <div className="d-flex">
          <div className={styles.treatment_input}>
            <input
              data-testid="treatment_input"
              type="text"
              className={`getFrequency${type === "secondary" ? "Sec" : ""}`}
              onBlur={(e) => onFrequencyChange(e, index, type)}
              defaultValue={item.frequence ?? ""}
            />
          </div>
          <div className={styles.treatment_select}>
            <select
              data-testid="treatment_select"
              className={`getFrequencyType${type === "secondary" ? "Sec" : ""}`}
              onChange={(e) => onFrequencyTypeChange(e, index, type)}
              defaultValue={item.frequenceType ?? ""}
            >
              <option>Days</option>
              <option>Hrs</option>
            </select>
          </div>
        </div>
        <div className={`d-flex ${styles.error_message}`}>{numValidator === index ? "please Select a number" : null}</div>
      </>
    )}
  </div>
);
